import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AllService } from './services/all.service';
import { HttpClientModule } from '@angular/common/http';
import { BasicModule } from './basic/basic.module';

@NgModule({
  declarations: [
    AppComponent,
  ],
  imports: [
    HttpClientModule,
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    BasicModule
  ],
  providers: [
    AllService
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
